
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("a0Cao", function(module, exports) {
/* SpaceViewsMenu.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $gyUf8 = parcelRequire("gyUf8");


var $4n1IT = parcelRequire("4n1IT");


var $lpNn5 = parcelRequire("lpNn5");


var $1B9Aq = parcelRequire("1B9Aq");


var $1LOGx = parcelRequire("1LOGx");


var $1sCHt = parcelRequire("1sCHt");


var $jmjWc = parcelRequire("jmjWc");

var $luv00 = parcelRequire("luv00");


var $epLE5 = parcelRequire("epLE5");


var $2vuKf = parcelRequire("2vuKf");


var $9wGTI = parcelRequire("9wGTI");




const $90e7d6468ec2564b$export$edb9b52ab3f1abbb = (ref)=>{
    {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [isIntersecting, setIntersecting] = (0, $cozmU.useState)(false);
        // eslint-disable-next-line
        const observer = new IntersectionObserver(([entry])=>setIntersecting(entry.isIntersecting));
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $cozmU.useEffect)(()=>{
            observer.observe(ref.current);
            // Remove the observer as soon as the component is unmounted
            return ()=>{
                observer.disconnect();
            };
        });
        return isIntersecting;
    }
};



const $4dd7628757ed68c6$var$SpaceViewsMenuContentLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "UQZ8V",
    name: "SpaceViewsMenuContentLoader",
    loader: async ()=>(await (parcelRequire("hRClj"))).SpaceViewsMenuContent
});

const $4dd7628757ed68c6$var$useLazyOptionClickedAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("5wQtO"))).fireSpaceViewsOptionClickedAnalytics);

const $4dd7628757ed68c6$var$useLazyTriggerClickedAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("5wQtO"))).fireSpaceViewsTriggerClickedAnalytics);
const $4dd7628757ed68c6$var$i18n = (0, $kSwu1.defineMessages)({
    menuTooltipForContent: {
        id: "space-views.space.menu.tooltip.content",
        defaultMessage: "Change view"
    },
    disabledMenuTooltipForContent: {
        id: "space-views.space.menu.tooltip.content.disabled",
        defaultMessage: "Filtering is disabled when editing multiple items"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $4dd7628757ed68c6$var$CustomPopupContainerWithToken = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDKxmn _42Yu6BE7ZR _0KLXruoI2d _2OUyjtGk8v _1zr6Dc98eZ _0htemXYbGa _067LceT6kp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $4dd7628757ed68c6$var$CustomPopupContainerWithoutToken = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDKxmn _42Yu6BE7ZR _0KLXruoI2d _2OUyjtGk8v _1zr6Dc98eZ _0htemXYbGa _067LceT6kp",
            __cmplp.className
        ])
    });
}); // same styles as a tooltip but with narrower width (FG + fallback for borderRadius)
const $4dd7628757ed68c6$var$tooltipStylesWithToken = null;
const $4dd7628757ed68c6$var$tooltipStylesWithoutToken = null;
const $4dd7628757ed68c6$var$ToolTipOverride = /*#__PURE__*/ (0, $cozmU.forwardRef)(function ToolTipOverride({ children: children, tooltipStyles: tooltipStyles, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1B9Aq.default), {
        ...props,
        ref: ref,
        className: (0, $hekY6.default)([
            tooltipStyles ?? "_2uo31fgozt _0bjKvDKxmn _2sNsIg7NXe _0Of8r24Jdh _1ZnuxbZimw _1wydGW4Jdh _2Zuz6QZimw _1UtDYze5R3 _1EqgXlQ0ex"
        ])
    }, children);
}); // Passed through IconButton's render-prop path so the icon size can be overridden. Declared at
// module scope so the reference is stable across renders.
const $4dd7628757ed68c6$var$smallFilterIcon = (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1LOGx))), {
        ...iconProps,
        size: "small"
    });
const $4dd7628757ed68c6$export$c0941f68287dbcd1 = ({ selection: selection, setSelection: setSelection, intl: intl, isWhiteboardBetaEnabled: isWhiteboardBetaEnabled, triggerRef: externalTriggerRef, isCompact: isCompact })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [isMultiSelectActive] = (0, $2vuKf.useIsMultiSelectActive)();
    const handleClose = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const ref = (0, $cozmU.useRef)(null);
    const isVisible = (0, $90e7d6468ec2564b$export$edb9b52ab3f1abbb)(ref);
    (0, $cozmU.useEffect)(()=>{
        if (!isVisible) {
            if (isOpen) setIsOpen(false);
        }
    }, [
        isVisible,
        isOpen
    ]);
    const fireOptionClickedAnalytics = $4dd7628757ed68c6$var$useLazyOptionClickedAnalytics(createAnalyticsEvent, selection);
    const setAndClose = (0, $cozmU.useCallback)((option)=>{
        setSelection(option);
        setIsOpen(false);
        fireOptionClickedAnalytics(option);
    }, [
        setSelection,
        fireOptionClickedAnalytics
    ]);
    const fireTriggerClickedAnalytics = $4dd7628757ed68c6$var$useLazyTriggerClickedAnalytics(createAnalyticsEvent, selection);
    const onTriggerClick = (0, $cozmU.useCallback)(()=>{
        setIsOpen((o)=>!o);
        fireTriggerClickedAnalytics();
    }, [
        fireTriggerClickedAnalytics
    ]);
    const CustomPopupContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, ...props }, ref)=>// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        (0, $9wGTI.fg)('confluence_frontend_tokenize_border') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4dd7628757ed68c6$var$CustomPopupContainerWithToken, {
            ...props,
            ref: ref
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4dd7628757ed68c6$var$CustomPopupContainerWithoutToken, {
            ...props,
            ref: ref
        }, children));
    const tooltipOptions = {
        position: 'bottom-end',
        component: (p)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4dd7628757ed68c6$var$ToolTipOverride, {
                ...p,
                tooltipStyles: // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
                (0, $9wGTI.fg)('confluence_frontend_tokenize_border') ? $4dd7628757ed68c6$var$tooltipStylesWithToken : $4dd7628757ed68c6$var$tooltipStylesWithoutToken
            })
    };
    const getTriggerButton = (triggerProps)=>{
        // Combine the popup's ref with external ref (if provided)
        const combinedRef = (element)=>{
            // Set the popup system's ref
            if (triggerProps.ref) {
                if (typeof triggerProps.ref === 'function') triggerProps.ref(element);
                else triggerProps.ref.current = element;
            } // Set external ref if provided - this connects our parent's ref to the DOM element
            if (externalTriggerRef) externalTriggerRef.current = element;
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            ...triggerProps,
            ref: combinedRef,
            icon: isCompact ? $4dd7628757ed68c6$var$smallFilterIcon : (0, (/*@__PURE__*/$parcel$interopDefault($1LOGx))),
            appearance: isCompact ? 'subtle' : undefined,
            spacing: isCompact ? 'compact' : undefined,
            onClick: onTriggerClick,
            isSelected: isOpen,
            label: isMultiSelectActive ? intl.formatMessage($4dd7628757ed68c6$var$i18n.disabledMenuTooltipForContent) : intl.formatMessage($4dd7628757ed68c6$var$i18n.menuTooltipForContent),
            isDisabled: isMultiSelectActive,
            isTooltipDisabled: false,
            tooltip: tooltipOptions
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: ref,
        "data-vc": "space-views-menu",
        ...ssrPlaceholderIdProp
    }, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gyUf8.default), {
        isTinted: false,
        shouldAllowClickThrough: !isOpen,
        onBlanketClicked: handleClose,
        testId: "space-views-menu-blanket"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        isOpen: isOpen,
        onClose: handleClose,
        content: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4dd7628757ed68c6$var$SpaceViewsMenuContentLoader, {
                selection: selection,
                setSelection: setAndClose,
                intl: intl,
                ...props
            }),
        popupComponent: CustomPopupContainer,
        zIndex: (0, $9wGTI.fg)('platform-dst-motion-uplift-popup') ? 1000 : undefined,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $4dd7628757ed68c6$var$i18n.menuTooltipForContent),
                position: isWhiteboardBetaEnabled ? 'top' : 'bottom',
                hideTooltipOnMouseDown: true
            }, getTriggerButton(triggerProps))),
        placement: "bottom-start",
        shouldRenderToParent: true
    }));
};
const $4dd7628757ed68c6$export$74e94f45f06d0cbd = (0, $kSwu1.injectIntl)($4dd7628757ed68c6$export$c0941f68287dbcd1);
module.exports["MenuComponent"] = $4dd7628757ed68c6$export$c0941f68287dbcd1;
module.exports["SpaceViewsMenu"] = $4dd7628757ed68c6$export$74e94f45f06d0cbd;

});

parcelRegister("epLE5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $dfceb6b0f6d6cccb$export$729b27bc0f344ffe = (loader)=>{
    return (...deps)=>(0, $cozmU.useCallback)((...args)=>{
            return loader().then((thunk)=>thunk(...deps)(...args));
        }, // Linter doesn't like spread syntax
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            ...deps
        ]);
};
module.exports["createLazyCallbackHook"] = $dfceb6b0f6d6cccb$export$729b27bc0f344ffe;

});

parcelRegister("hRClj", function(module, exports) {

let $d01520f758c1c844$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d01520f758c1c844$var$load("7Y0AX"),
    $d01520f758c1c844$var$load("cWvhX")
]).then(()=>parcelRequire('4IxWt'));

});

parcelRegister("5wQtO", function(module, exports) {

let $4068a64b15f3200a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4068a64b15f3200a$var$load("60m6Z").then(()=>parcelRequire('kb7fE'));

});

parcelRegister("9cZ1w", function(module, exports) {

var $epLE5 = parcelRequire("epLE5");


const $486bada329940e5a$export$f6e059b56d9aeb26 = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("gK28h"))).showCreateWithRovoModalCloseFeedbackFlagThunk);
module.exports["useLazyShowFeedbackFlag"] = $486bada329940e5a$export$f6e059b56d9aeb26;

});

parcelRegister("gK28h", function(module, exports) {

let $c30298b540cdfafe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c30298b540cdfafe$var$load("6wr18"),
    $c30298b540cdfafe$var$load("dQT3c"),
    $c30298b540cdfafe$var$load("4nZ85"),
    $c30298b540cdfafe$var$load("ffEVr"),
    $c30298b540cdfafe$var$load("kHXvF"),
    $c30298b540cdfafe$var$load("iWnyc"),
    $c30298b540cdfafe$var$load("hhss7"),
    $c30298b540cdfafe$var$load("9TOep"),
    $c30298b540cdfafe$var$load("4g6rd"),
    $c30298b540cdfafe$var$load("7EorR"),
    $c30298b540cdfafe$var$load("k7MRD")
]).then(()=>parcelRequire('hlCkz'));

});

parcelRegister("zCcSI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $kwzZh = parcelRequire("kwzZh");


var $6mKj3 = parcelRequire("6mKj3");


var $32x2E = parcelRequire("32x2E");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $8aF6s = parcelRequire("8aF6s");


var $jyA9t = parcelRequire("jyA9t");


var $c96tF = parcelRequire("c96tF");


var $9cZ1w = parcelRequire("9cZ1w");

const $e34c3f63766da5b3$var$CLOSE_MODAL_DELAY = 500;
const $e34c3f63766da5b3$var$AGENT_MENU_CREATE_SOURCE = 'confluence-rovo-agent-menu-create-agent';
const $e34c3f63766da5b3$export$a9c99c9d804e8c41 = ({ assistanceServiceConfigHeaders: assistanceServiceConfigHeaders = {}, preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose = false, preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose = false })=>{
    const { cloudId: cloudId, orgId: orgId, userId: userId } = (0, $bQm3c.useSessionData)();
    const emojiProvider = (0, $cozmU.useMemo)(()=>{
        return (0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
            cloudId: cloudId,
            userId: userId
        });
    }, [
        userId,
        cloudId
    ]);
    // Keep the config object identity stable when its semantic inputs are stable.
    const assistanceServiceConfig = (0, $cozmU.useMemo)(()=>({
            headers: assistanceServiceConfigHeaders,
            baseUrl: '/gateway/api/assist'
        }), [
        assistanceServiceConfigHeaders
    ]);
    return (0, $cozmU.useMemo)(()=>({
            displaySubmitFlag: true,
            siteId: cloudId,
            product: 'confluence',
            orgId: orgId,
            assistanceServiceConfig: assistanceServiceConfig,
            emojiProvider: emojiProvider,
            userId: userId ?? undefined,
            preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose,
            preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose
        }), [
        assistanceServiceConfig,
        cloudId,
        emojiProvider,
        orgId,
        preventAbortRequestsOnStagingModalClose,
        preventAbortRequestsOnStandaloneChatClose,
        userId
    ]);
};
const $e34c3f63766da5b3$export$577864d1e6735f1b = ({ flags: flags, customGreeting: customGreeting, shouldShowGreeting: shouldShowGreeting, shouldHideFeedback: shouldHideFeedback })=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const intl = (0, $kSwu1.useIntl)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const navigateToObject = (0, $cozmU.useCallback)(async ({ baseUrl: baseUrlNav, path: path })=>{
        (0, $c96tF.createNavigateToObject)(push)({
            baseUrl: baseUrlNav,
            path: path
        });
        // artifical delay before closing the modal gives the app a moment to transition to the created object while the modal is still open, this creates a smoother transition from modal to new object.
        // For non-SPA transitions, a full page reload will happen so this delay will be ignored
        await new Promise((r)=>setTimeout(r, $e34c3f63766da5b3$var$CLOSE_MODAL_DELAY));
    }, [
        push
    ]);
    const showCreateWithRovoModalCloseFeedbackFlag = (0, $9cZ1w.useLazyShowFeedbackFlag)(flags, intl, showModal, createAnalyticsEvent);
    const handleCloseSmartCreate = (0, $cozmU.useCallback)(({ feedbackVariant: feedbackVariant, sourceEntryPoint: sourceEntryPoint, currentConversationId: currentConversationId, traceId: traceId, requestId: requestId, remixMetadata: remixMetadata, contentType: contentType, contentMode: contentMode })=>{
        if (shouldHideFeedback) return;
        if (feedbackVariant === undefined) return;
        showCreateWithRovoModalCloseFeedbackFlag({
            feedbackVariant: feedbackVariant,
            sourceEntryPoint: sourceEntryPoint,
            contentType: contentType,
            contentMode: contentMode,
            cloudId: cloudId,
            currentConversationId: currentConversationId ?? undefined,
            traceId: traceId,
            requestId: requestId,
            remixMetadata: remixMetadata
        });
    }, [
        showCreateWithRovoModalCloseFeedbackFlag,
        shouldHideFeedback,
        cloudId
    ]);
    const handleCreateAgent = (0, $cozmU.useCallback)(()=>{
        if (!(0, $6mKj3.expVal)('cc_contextual_agent_creation_v2', 'isEnabled', false)) return;
        openModal({
            entryPoint: $e34c3f63766da5b3$var$AGENT_MENU_CREATE_SOURCE,
            initialOutcomeType: 'agent',
            lockInitialOutcomeType: true
        });
    }, [
        openModal
    ]);
    // Keep uiConfig identity stable when handler/greeting inputs are stable.
    return (0, $cozmU.useMemo)(()=>({
            customHandlers: {
                onCreateAgentClick: handleCreateAgent,
                handleSubmitSmartCreate: navigateToObject,
                handleCloseSmartCreate: handleCloseSmartCreate
            },
            elements: {
                voiceDictationButton: true,
                shouldShowGreeting: shouldShowGreeting ?? undefined
            },
            customGreeting: customGreeting ?? undefined
        }), [
        customGreeting,
        handleCloseSmartCreate,
        handleCreateAgent,
        navigateToObject,
        shouldShowGreeting
    ]);
};
module.exports["useConversationAssistantConfig"] = $e34c3f63766da5b3$export$a9c99c9d804e8c41;
module.exports["useConversationAssistantUiConfig"] = $e34c3f63766da5b3$export$577864d1e6735f1b;

});

parcelRegister("c96tF", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $8f856ee350559225$export$b2e60ce4b3907e57 = (baseUrl)=>{
    const host = window.location.host;
    return baseUrl.includes(host) && baseUrl.includes((0, $jlIaF.CONTEXT_PATH));
};
// database need flow query param for special case handling
const $8f856ee350559225$var$addFlowParam = (baseUrl, path)=>{
    const url = new URL(path, baseUrl);
    url.searchParams.set('flow', 'aiCreate');
    return url.pathname + url.search;
};
const $8f856ee350559225$export$38454a8d1321e65a = (push)=>({ baseUrl: baseUrl, path: path })=>{
        const isDatabase = Boolean((0, $1NBp8.DATABASE_VIEW).match(`${baseUrl}${path}`));
        let finalPath = path;
        if (isDatabase) finalPath = $8f856ee350559225$var$addFlowParam(baseUrl, path);
        if ($8f856ee350559225$export$b2e60ce4b3907e57(baseUrl)) push((0, $jlIaF.CONTEXT_PATH) + finalPath);
        else window.location.href = `${baseUrl}${finalPath}`;
    };
module.exports["createNavigateToObject"] = $8f856ee350559225$export$38454a8d1321e65a;

});


//# sourceMappingURL=SpaceViewsMenu.d3bade5b.js.map
